import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboardChart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.15796 14.5C5.15796 15.4283 5.54612 16.3185 6.23704 16.9749C6.92797 17.6313 7.86506 18 8.84217 18C9.81928 18 10.7564 17.6313 11.4473 16.9749C12.1382 16.3185 12.5264 15.4283 12.5264 14.5C12.5264 13.5717 12.1382 12.6815 11.4473 12.0251C10.7564 11.5687 9.81928 11 8.84217 11C7.86506 11 6.92797 11.5687 6.23704 12.0251C5.54612 12.6815 5.15796 13.5717 5.15796 14.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.57886 11V14.5156L10.6841 17",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6843 11H18.8422",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6843 14H18.8422",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6843 17H18.8422",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33333 4H20.6667C20.6667 4 22 4 22 5.275V19.725C22 19.725 22 21 20.6667 21H3.33333C3.33333 21 2 21 2 19.725V5.275C2 5.275 2 4 3.33333 4Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 8H22",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDashboardChart);
export default ForwardRef;
